const updates = [
  {
    date: '2026-08-01',
    tag: '新片上线',
    text: '《长安十二时辰 第二季》全 40 集高清版已更新完毕，蓝光画质同步上线。',
  },
  {
    date: '2026-07-30',
    tag: '剧集更新',
    text: '《风云再起之龙虎斗》更新至第 28 集，剧情进入高潮阶段，热度持续攀升。',
  },
  {
    date: '2026-07-28',
    tag: '新片上线',
    text: '科幻大片《星际救援：新纪元》高清版正式登陆，视觉效果获观众一致好评。',
  },
  {
    date: '2026-07-26',
    tag: '系统公告',
    text: '播放引擎全面升级，新增智能画质自适应功能，低带宽用户观看体验大幅提升。',
  },
  {
    date: '2026-07-24',
    tag: '综艺更新',
    text: '《人间烟火气》最新一期上线，探访云南秘境美食，画面治愈感满满。',
  },
  {
    date: '2026-07-22',
    tag: '新片上线',
    text: '悬疑犯罪片《深渊之下》高清版已上线，多重反转结局引发热烈讨论。',
  },
  {
    date: '2026-07-20',
    tag: '动漫更新',
    text: '《少年江湖行》更新至第 18 话，画风持续高水准，口碑稳步上升。',
  },
  {
    date: '2026-07-18',
    tag: '剧集更新',
    text: '热门都市剧《深夜办公室》第三季正式回归，首播当日播放量突破 500 万。',
  },
  {
    date: '2026-07-16',
    tag: '专题上线',
    text: '「夏日影单」暑期特别专题上线，精选 50 部适合夏天观看的经典电影。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            片源更新、系统公告与专题活动，不错过每一个精彩时刻
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-200">
            {updates.map((item, idx) => (
              <div key={idx} className="relative mb-6 last:mb-0">
                <div className="absolute -left-[25px] md:-left-[29px] w-3 h-3 rounded-full bg-accent-500 border-2 border-background-100"></div>
                <div className="flex items-center gap-3 mb-1.5 flex-wrap">
                  <span className="text-xs text-foreground-500">{item.date}</span>
                  <span className="text-xs font-medium text-accent-500 bg-accent-100/70 px-2 py-0.5 rounded-full">
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}